import { EntityOtherComponent } from './../other/entity-other.component';
import { EntityOtherService } from 'app/entities/other/entity-other.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { EntityDetailsService } from 'app/entities/details/entity-details.service';
import { EntityRouteService } from 'app/entities/entity-route.service';
import { EntityIdDetails, EntityType } from 'app/shared/models/entity-id-details.model';
import { environment } from 'environments/environment';

@Component({
  templateUrl: './entity-monitoring.component.html'
})

export class EntityMonitoringComponent extends EntityOtherComponent implements OnInit, OnDestroy {
  entityIdDetails: EntityIdDetails;
  showGWTFrame = !environment.isDevelopmentEnv;
  private routeSubscription: any;
  private detailsSubscription: any;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public entityDetailsService: EntityDetailsService,
    public entityRouteService: EntityRouteService,
    public domSanitizer: DomSanitizer,
    public entityOtherService: EntityOtherService) {
    super(route, router, domSanitizer, entityDetailsService, entityOtherService);
  }

  ngOnInit() {
    this.entityIdDetails = this.entityDetailsService.getEntityIdDetails();

    this.detailsSubscription = this.entityDetailsService.entityDetailsUpdated.subscribe(
      (entityDetails) => {
        this.entityIdDetails = entityDetails;
      }
    );

    this.routeSubscription = this.route.parent.params.subscribe(params => {
      const routeEntityId = params['entityId'] ? parseInt(params['entityId'], 10) : null;
      if (routeEntityId && (!this.entityIdDetails || !this.entityIdDetails.entityId || this.entityIdDetails.entityId !== routeEntityId)) {
        this.loadEntityFromRoute(routeEntityId);
      }
    });
  }

  ngOnDestroy() {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
    if (this.detailsSubscription) {
      this.detailsSubscription.unsubscribe();
    }
  }

  private loadEntityFromRoute(entityId: number) {
    this.entityRouteService.getEntityRouteDetails(entityId).subscribe(
      response => {
        const data = response && response.arrResult ? response.arrResult : response;
        if (!data || !data.entityType) return;

        const details = new EntityIdDetails();
        details.entityId = data.entityId || entityId;
        details.orgId = data.entityType === 'org' ? (data.underlyingId || 0) : undefined;
        details.personId = data.entityType === 'person' ? (data.underlyingId || 0) : undefined;
        details.entityType = data.entityType === 'person' ? EntityType.PERSON : EntityType.ORGANISATION;

        this.entityDetailsService.setEntityIdDetails(details);
      },
      () => {
        // Route details failed; parent dossier may still load. Keep existing entityIdDetails.
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/monitoring/entity-monitoring.component.ts